import { Box, Stack, TextField } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";
import { type AccountSwitcherUser, type UserDetails } from "../../Shared/AccountSwitcher/types";
import { AccountSwitcherOptionGroupMobile } from "./AccountSwitcherOptionGroup";

interface AccountSwitcherDropdownAdminMobileProps {
  workerDetails: UserDetails;
  workplaceDetails: UserDetails;
  onUserClicked: (user: AccountSwitcherUser) => void;
  onAdminClicked: () => void;
  onSearchChanged: (searchTerm: string) => void;
}

export function AccountSwitcherDropdownAdminMobile(props: AccountSwitcherDropdownAdminMobileProps) {
  const { workerDetails, workplaceDetails, onUserClicked, onAdminClicked, onSearchChanged } = props;

  return (
    <>
      <Stack padding={2} gap={2}>
        {/* TODO: replace text field, with redesigned component */}
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Search agents or workplaces..."
          onChange={(event) => {
            onSearchChanged(event.target.value);
          }}
        />
        <Button fullWidth variant="secondary" onClick={onAdminClicked}>
          Switch To Administrator
        </Button>
      </Stack>
      <Box>
        <Box data-testid="account-switcher-agents" sx={{ marginBottom: 3 }}>
          <Text
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.navbar?.gradient,
            })}
          >
            AGENTS
          </Text>
          <Box>
            <AccountSwitcherOptionGroupMobile
              userDetails={workerDetails}
              onUserClicked={onUserClicked}
            />
          </Box>
        </Box>
        <Box>
          <Text
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.navbar?.gradient,
            })}
          >
            WORKPLACES
          </Text>
          <Box>
            <AccountSwitcherOptionGroupMobile
              userDetails={workplaceDetails}
              onUserClicked={onUserClicked}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}
